import { useInjection } from 'libs/uikit/ioc/React';
import { useAsync } from 'libs/uikit/lib';
import { IAuthenticationStore } from 'services/web/react/core/Abstractions/IAuthenticationStore';

export function LogoutCallback() {
  const authenticationStore = useInjection(IAuthenticationStore);

  useAsync(async () => {
    await authenticationStore.logoutCallback();
  }, []);

  return null;
}
